import { ScheduleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import type { FC } from 'react';

import IntlMessages from '@src/util/IntlMessages';

export type CoverCurrentJourneyLabelProps = {
  /** Assigned journey name; empty / null shows the no-journey chip. */
  journeyName?: string | null;
};

/**
 * Current-journey cell for cover/replace candidate tables.
 * Assigned names stay plain text; missing assignment uses a success Tag so it
 * reads as available / simpler to cover, not as a problem state.
 */
export const CoverCurrentJourneyLabel: FC<CoverCurrentJourneyLabelProps> = ({
  journeyName,
}) => {
  const name = journeyName?.trim();
  if (name) {
    return <span>{name}</span>;
  }

  return (
    <Tag className="gx-mb-0 gx-mr-0" color="success" icon={<ScheduleOutlined />}>
      <IntlMessages id="workJourney.management.cover.replace.noJourney" />
    </Tag>
  );
};
